import styles from './Checkbox.module.scss';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import Content from '@ui/components/Content/Content';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox as BaseCheckbox } from '@ariakit/react';
import classNames from 'classnames';

const Checkbox = forwardRef(
  (
    {
      align = null,
      // Don't remove children because we don't want to spread it into BaseCheckbox
      // eslint-disable-next-line no-unused-vars
      children = null,
      className = null,
      disabled = false,
      id = null,
      label = '',
      name = null,
      noMargin = false,
      required = false,
      store = null,
      variant = 'default',
      withParser = false,
      ...props
    },
    ref,
  ) => (
    <label
      className={classNames(
        styles.container,
        {
          [styles[align]]: align,
          [styles.disabledContainer]: disabled,
        },
        className,
      )}
      htmlFor={id}
      id={id ? `${id}-label` : null}
    >
      <BaseCheckbox
        aria-required={required}
        className={styles.checkbox}
        disabled={disabled}
        id={id}
        name={name}
        ref={ref}
        required={required}
        store={store}
        {...props}
      />
      <div
        className={classNames(styles.checkmark, styles[variant], {
          [styles.noMargin]: noMargin,
          [styles.disabled]: disabled,
        })}
      >
        <FontAwesomeProIcon icon="check" role="presentation" />
      </div>
      <div>
        {withParser ? (
          <Content noSpacing withParser={withParser}>
            {label}
          </Content>
        ) : (
          label
        )}
      </div>
    </label>
  ),
);

Checkbox.propTypes = {
  align: PropTypes.oneOf(['center']),
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  noMargin: PropTypes.bool,
  required: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  /** `useCheckboxStore()` return value from `@ariakit/react` */
  store: PropTypes.object,
  variant: PropTypes.oneOf(['default', 'circle']),
  withParser: PropTypes.bool,
  /* eslint-enable react/forbid-prop-types */
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
